// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sv9E2Y6IIQek10uMw4XZ {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 1rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem
}
.CR4oA5jqPJ7K05OioJaB {
    display: flex;
    justify-content: flex-start;
    gap: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem
}
.JYzyi4jMzRDKo1Bc2gLa {
    font-family: Noto Sans;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.PvW8wlJLM5gEZ9hBvtR5 {
    font-family: Noto Sans;
    font-weight: 400
}
`, "",{"version":3,"sources":["webpack://./src/pages/PledgeConsentApproval/components/RedeemPledgeDetailsForCustomerConsent/RedeemPledgeDetailsForCustomerConsent.module.css"],"names":[],"mappings":"AACE;IAAA,aAA6C;IAA7C,gDAA6C;IAA7C,aAA6C;IAA7C,uBAA6C;SAA7C,kBAA6C;IAA7C,oBAA6C;IAA7C;AAA6C;AAG7C;IAAA,aAAuC;IAAvC,2BAAuC;IAAvC,WAAuC;IAAvC,mBAAuC;IAAvC;AAAuC;AAGvC;IAAA,sBAAiD;IAAjD,gBAAiD;IAAjD,oBAAiD;IAAjD;AAAiD;AAGjD;IAAA,sBAAmC;IAAnC;AAAmC","sourcesContent":[".infoRowContainer {\n  @apply grid grid-cols-2 gap-y-4 gap-x-10 py-3;\n}\n.labelValueWrapper {\n  @apply flex text-sm justify-start gap-2;\n}\n.label {\n  @apply text-gray-400 font-dashboardSub font-inter;\n}\n.value {\n  @apply font-dashboardSub font-inter;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoRowContainer": `Sv9E2Y6IIQek10uMw4XZ`,
	"labelValueWrapper": `CR4oA5jqPJ7K05OioJaB`,
	"label": `JYzyi4jMzRDKo1Bc2gLa`,
	"value": `PvW8wlJLM5gEZ9hBvtR5`
};
export default ___CSS_LOADER_EXPORT___;
